//FUZIONE PER IL CAMBIO MAPPA
import React, { Component } from 'react'
import { TileLayer, LayersControl, Marker, WMSTileLayer } from 'react-leaflet'
import './ChangeMap.css'
import L from 'leaflet'
function ChangeMap(){


    return<LayersControl  position="topright">
      <LayersControl.BaseLayer checked name="OpenStreetMap.Mapnik">
        <TileLayer
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://b.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
      </LayersControl.BaseLayer>
      <LayersControl.BaseLayer name="OpenStreetMap.BlackAndWhite">
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://tiles.wmflabs.org/bw-mapnik/{z}/{x}/{y}.png"
        />
      </LayersControl.BaseLayer>
      <LayersControl.Overlay name="Marker with popup">
      <WMSTileLayer
      format="image/png"
      layers={"raster:ortofoto_2016"}
      url="http://webgis.regione.sardegna.it/geoserverraster/ows?service=WMS"
      transparent="true"
      
    />
    
      </LayersControl.Overlay>
      <LayersControl.BaseLayer name="Ortofoto">
        <TileLayer
          attribution='Map data: &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, <a href="http://viewfinderpanoramas.org">SRTM</a> | Map style: &copy; <a href="https://opentopomap.org">OpenTopoMap</a> (<a href="https://creativecommons.org/licenses/by-sa/3.0/">CC-BY-SA</a>)'
          url="http://webgis.regione.sardegna.it/tms/ortofoto2013_EPSG3003/{z}/{x}/{y}.jpg"
          tms="true"
          crs = {L.CRS.EPSG900084}
            // L.CRS.EPSG900913
  // L.CRS.EPSG3395
  // L.CRS.EPSG3857
  // L.CRS.EPSG4326
        />
      </LayersControl.BaseLayer>
      </LayersControl>

}
export default ChangeMap;